import {Component, Input} from '@angular/core';
import {ButtonPadraoComponent} from "../button-padrao/button-padrao.component";

@Component({
  selector: 'app-balao-informativo',
  standalone: true,
    imports: [
        ButtonPadraoComponent
    ],
  templateUrl: './balao-informativo.component.html',
  styleUrl: './balao-informativo.component.css'
})
export class BalaoInformativoComponent {

  @Input() titulo?: string;
  @Input() texto?: string;
  @Input() heigth?: string;
  @Input() width?: string;

}
